// InputField.jsx
import React from "react";
import "./narrowInput.css";

const NarrowInputField = ({
  title,
  subLabel, // New prop for sub-label
  placeholder,
  isRequired,
  value,
  onChange,
  readOnly = false,
  halfWidth = false,
  name,
}) => {
  return (
    <div className={`input-field-container ${halfWidth ? "half-width" : ""}`}>
      <label className="input-label">
        {title} {isRequired && <span className="required">*</span>}
      </label>
      {subLabel && <div className="sub-label">{subLabel}</div>}
      <input
        name={name} // Added the name attribute
        type="text"
        required={isRequired}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        className={`narrow-input-field ${readOnly ? "read-only" : ""}`}
      />
    </div>
  );
};

export default NarrowInputField;
